var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site"},[_c('navbar'),_vm._v(" "),_c('main',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-lg-8 col-lg-offset-2 col-md-12 col-sm-12 col-xs-12"},[(_vm.isLoading)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader"})]):_c('router-view')],1)])]),_vm._v(" "),_c('bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ce08ab6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 